package uz.ferro.erp.feature.menu.model

import react.FC

data class MenuItem(
    val icon: FC<*>? = null,
    val title: String? = null,
    val action: () -> Unit
)
